import React, { Component } from 'react';
import MalidCard from './MalidCard';

class BlondalView extends Component {
	render() {
		return (
			<MalidCard title={window.l('ritmalssafn_title')}
			subTitle={window.l('ritmalssafn_subtitle')}
				count={this.props.count}
				visible={(this.props.data && this.props.data.length > 0)}
				frontPage={this.props.frontPage}
				aboutText={window.l('ritmalssafn_about')}
				database="ritmalssafn">
				{
					this.props.data && this.props.data.map(function(item, index) {
						return <React.Fragment key={index}>
							{
								index > 0 && <hr/>
							}
							<p className="card-text" key={index}>
								<strong><a target='_blank' href={'http://ritmalssafn.arnastofnun.is/daemi/'+item.id}>{item.fletta}</a></strong> {item.ordflokkur}<br/>
								{item.fjoldi_aldur}
								{/*(item.fjoldi == 0 ? 'Ekkert tölvutækt dæmi.' : (item.fjoldi+' '+(item.aldur && item.aldur.length > 0 ? item.aldur.toLowerCase() : 'dæmi í Ritmalssafni')))*/}
							</p>
						</React.Fragment>
					})
				}
			</MalidCard>
		);
	}
}

export default BlondalView;



// WEBPACK FOOTER //
// ./src/components/RitmalssafnView.js